import { createElement, ReactNode, ReactElement, AnchorHTMLAttributes } from 'react';
import cn from 'classnames';

import Link from 'components/link/Link';

interface OuterLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  refer?: (node: HTMLElement | null) => void;
  noHoverEffect?: boolean;
  attributes?: Record<string, string | number | boolean>;
}

interface InnerLinkProps {
  children: ReactNode;
  className?: string;
}

interface LinkWrapperReturn {
  OuterLink: React.FC<OuterLinkProps>;
  InnerLink: React.FC<InnerLinkProps>;
}

const element = (
  isLink: boolean,
  url: string = '',
  trackUrl?: string,
  noHover?: boolean,
  className?: string,
  children?: ReactNode,
  ref?: (node: HTMLElement | null) => void,
  attributes?: Record<string, string | number | boolean>
): ReactElement => {
  if (isLink) {
    return createElement(Link, { url, trackUrl, noHoverEffect: noHover, className, ref, ...attributes }, children);
  }
  return createElement('div', { className, ref }, children);
};

const LinkWrapper = (shouldWrapInLink: boolean, url?: string, trackUrl?: string): LinkWrapperReturn => {
  const OuterLink: React.FC<OuterLinkProps> = ({ children, className, refer, noHoverEffect = true, attributes }) =>
    element(
      shouldWrapInLink,
      url,
      trackUrl,
      noHoverEffect,
      cn({ 'link-wrapper__outer-link': shouldWrapInLink }, className),
      children,
      refer,
      attributes
    );

  const InnerLink: React.FC<InnerLinkProps> = ({ children, className }) =>
    element(
      !shouldWrapInLink,
      url,
      trackUrl,
      false,
      cn({ 'link-wrapper__inner-link': shouldWrapInLink }, className),
      children
    );

  return {
    OuterLink,
    InnerLink
  };
};

LinkWrapper.displayName = 'LinkWrapper';

export default LinkWrapper;
